import React from 'react';
import { IconProps } from '.';

const SvgCategoryFood = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M4.698 9.464H2.25v.75c0 3.958 2.224 7.363 5.4 9.064v1.972h8.7v-1.972c3.176-1.7 5.4-5.106 5.4-9.064v-.75h-2.448C18.876 6.172 15.68 3.75 12 3.75c-3.68 0-6.876 2.422-7.302 5.714Zm1.52 0h11.564C17.36 7.147 15.016 5.25 12 5.25S6.64 7.147 6.218 9.464Zm-2.437 1.5a8.768 8.768 0 0 0 4.94 7.175l.429.204v1.407h5.7v-1.407l.428-.204a8.768 8.768 0 0 0 4.94-7.175H3.782Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCategoryFood;
